// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () { };
    var methods = [
        "assert", "clear", "count", "debug", "dir", "dirxml", "error",
        "exception", "group", "groupCollapsed", "groupEnd", "info", "log",
        "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd",
        "timeline", "timelineEnd", "timeStamp", "trace", "warn"
    ];

    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }

    $("ul.nav.nav-tabs li a").click(function () {
        $(this).parent().addClass("active").siblings().removeClass("active");
    });
}());

function DisableField(field) {
    $(field).attr("readonly", "readonly");
    $(field).addClass("default");
}

function EnableField(field) {
    $(field).removeAttr("readonly");
    $(field).removeClass("default");
}

(function ($) {
    $.fn.showLoader = function () {
        $(this).css('cursor', 'wait');
        $('#loader').show();
    };

    $.fn.hideLoader = function () {
        $('#loader').css('cursor', 'default');
        $('#loader').hide();
    };

    $.fn.pad = function (num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    };

    $.fn.setCurrentValue = function (control) {
        control.originalValue = control.value;
    };
    $.fn.valueChanged = function (control) {
        return control.value !== control.originalValue;
    };
    $.fn.setValidationError = function (errorId, controlGroupId, error) {
        $(errorId).html(error);
        $(controlGroupId).toggleClass("error", true);
    };
    $.fn.resetValidationError = function (errorId, controlGroupId) {
        $(errorId).html("");
        $(controlGroupId).toggleClass("error", false);
    };

    $.fn.wrapCheckbox = function() {
        $(this).find('input[type="checkbox"]').each(function() {
            $(this).wrap(function() {
                if ($(this).is(":checked")) {
                    return '<span class="custom-checkbox selected" />';
                } else if ($(this).is(":disabled")) {
                    return '<span class="custom-checkbox disabled" />';
                } else {
                    return '<span class="custom-checkbox" />';
                }
            }).css("opacity", 0);

            $(this).closest("span").bind("click", function() {
                $(this).not(":disabled").toggleClass("selected");
            });
        });

        return this;
    };

    $.fn.wrapRadiobuttons = function() {
        $(this).find('input[type="radio"]').each(function () {
            $(this).wrap(function () {
                return '<span class="custom-radiobutton" />';
            });
            $(this).after(function () {
                if ($(this).is(":disabled")) {
                    return '<label for="' + $(this).attr("id") + '" class="disabled"></label>'
                } else {
                    return '<label for="' + $(this).attr("id") + '"></label>'
                }
            });

            //$(this).closest("span").bind("click", function () {
            //    $(this).closest(".controls").find(".custom-radiobutton").removeClass("selected");
            //    $(this).not(":disabled").toggleClass("selected");
            //});
        });

        return this;
    };

    $(function () {
        $("form").wrapCheckbox();
        $("form").wrapRadiobuttons();

        $(".navbar-toggle").click(function () {
            var $nav = $(".nav-aside");

            if ($nav.is(":visible")) {
                $nav.slideUp(function () {
                    $nav.addClass("collapsed");
                });
            } else {
                $nav.slideDown(function () {
                    $nav.removeClass("collapsed");
                });
            }
        });

        $("input[placeholder]").placeholder();

        $(".focus").focus();

        $(".autocomplete").each(function () {
            var $this = $(this),
                source = $this.data("source");

            $this.autocomplete({ source: source });
        });

        $("tr[data-href]").click(function () {
            window.location = $(this).data("href");
        });

        $(".cropPhoto").each(function () {
            var cropPhoto = $(this);

            cropPhoto.imagesLoaded(function () {
                var trueWidth = cropPhoto.data("true-width"),
                    trueHeight = cropPhoto.data("true-height"),
                    $x1 = $("#" + cropPhoto.data("id-input-x1")),
                    $y1 = $("#" + cropPhoto.data("id-input-x2")),
                    $x2 = $("#" + cropPhoto.data("id-input-y1")),
                    $y2 = $("#" + cropPhoto.data("id-input-y2"));

                cropPhoto.Jcrop({
                    aspectRatio: 1,
                    minSize: [400, 400],
                    trueSize: [trueWidth, trueHeight],
                    setSelect: [$x1.val(), $y1.val(), $x2.val(), $y2.val()],
                    onSelect: updateCoords,
                    onChange: updateCoords
                });

                function updateCoords(c) {
                    $x1.val(Math.floor(c.x));
                    $y1.val(Math.floor(c.y));
                    $x2.val(Math.floor(c.x2));
                    $y2.val(Math.floor(c.y2));
                }
            });
        });

        $(".import-row-actions input[type=checkbox]").change(function () {
            var el = $(this);
            var otherCheckbox = el.parents("tr").find(".import-row-actions input[type=checkbox]").not(el);
            otherCheckbox.prop("checked", false).parent().removeClass("selected");
        });

        $(document).on("click", ".add-control", function () {
            var el = $(this);
            var masterElement = el.parents(".dynamic-fields");
            var groupElementHtml = el.parents(".control-group").html();

            var lastGroupElement = masterElement.find(".control-group:last-child");
            var newGroupElement = $(document.createElement('div'));

            newGroupElement.addClass("control-group");
            newGroupElement.html(groupElementHtml);

            var name = lastGroupElement.find("input").attr("name");
            var i = name.split("_");
            var num = Number(i[1]) + 1;

            newGroupElement.find("input")
                .attr("name", i[0] + "_" + num)
                .attr("id", i[0] + "_" + num);
            newGroupElement.find(".remove-control").attr("style", "");

            masterElement.append(newGroupElement);
        });

        $(document).on("click", ".remove-control", function () {
            var el = $(this);
            var groupElement = el.parents(".control-group");
            groupElement.remove();
        });


      $(document).on("click", ".accordion-header", function () {
            var $this = $(this),
                $parent = $(this).parent(".accordion");

            $parent.toggleClass("active");

            $parent.find(".accordion-content").slideToggle(200);
        });

      $(".accordion.active").each(function () {
        $(this).find(".accordion-content").slideToggle(200);
      });
    });
})(jQuery);